export const toolbarConfig = {
    plugins: 'link table lists',
    toolbar: 'undo redo | fontsizeselect  styleselect | bold italic underline | forecolor backcolor  removeformat table | numlist bullist | alignleft aligncenter alignright alignjustify ltr rtl | outdent indent |',
    height: 600,
    content_style: 'body { font-size:10.0pt;line-height:115%;font-family:EYInterstate Light }',
    color_map: [
      '000000', 'Black',
      '808080', 'Gray',
      'FFFFFF', 'White',
      'FF0000', 'Red',
      'FFFF00', 'Yellow',
      '008000', 'Green',
      '0000FF', 'Blue'
    ],
    menubar: false,
    statusbar: false,
    auto_focus: 'true',
    convert_urls: false,
    table_toolbar: '',
  };

  export const allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.ms-excel'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];